<script lang="ts">
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import SettingsClfFragment from "./SettingsClfFragment.svelte";
  import SettingsGeneralFragment from "./SettingsGeneralFragment.svelte";

  enum SettingPage {
    General = 1,
    Classifications,
  }

  let currentTab: SettingPage = SettingPage.General;
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Generale"
      active={currentTab == SettingPage.General}
      on:click={(_) => {
        currentTab = SettingPage.General;
      }}
    />
    <Tab
      label="Tabelle"
      active={currentTab == SettingPage.Classifications}
      on:click={(_) => {
        currentTab = SettingPage.Classifications;
      }}
    />
  </Tabs>

  {#if currentTab == SettingPage.General}
    <SettingsGeneralFragment />
  {/if}

  {#if currentTab == SettingPage.Classifications}
    <SettingsClfFragment />
  {/if}
</MainLayout>
